import { useQuery } from '@tanstack/react-query';
import { restaurantQueries } from '../api/restaurant-queries';

/** Single restaurant (branch) detail by id. */
export function useRestaurant(id: string | undefined, enabled = true) {
  return useQuery(restaurantQueries.detail(id ?? '', enabled && Boolean(id)));
}
